import React, { Component } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from "moment";
import { CFDateRangePicker } from 'datePicker';
import * as actions from '../schedules/redux/weekly_schedule_actions';

export class ScheduleWeekCalendar extends Component {
    constructor(props) {
        super(props)
        this.state = { 
            startDate: moment(props.date, "YYYY-MM-DD").isoWeekday(1), 
            endDate: moment(props.date, "YYYY-MM-DD").isoWeekday(7),            
            singleDate: moment(props.date, "YYYY-MM-DD")
        }


        if(this.props.actions.selectedDateAction)
            this.props.actions.selectedDateAction(
                moment(props.date, "YYYY-MM-DD").isoWeekday(1), 
                moment(props.date, "YYYY-MM-DD").isoWeekday(7), 
                this.selectedDate)

        this.setSelectedDate = this.setSelectedDate.bind(this)       
        this.onStartDateOffSetSelected = this.onStartDateOffSetSelected.bind(this)
    }

    componentWillReceiveProps(nextProps){
        if(this.props.date !== nextProps.date && nextProps.date !== undefined){
            this.setState({
                startDate: moment(nextProps.date, "YYYY-MM-DD").isoWeekday(1), 
                endDate: moment(nextProps.date, "YYYY-MM-DD").isoWeekday(7),
                singleDate: moment(nextProps.date, "YYYY-MM-DD")
            })
        }
    }

    setSelectedDate(startDate, endDate){
        if(this.props.actions.selectedDateAction)
            this.props.actions.selectedDateAction(startDate, endDate, this.selectedDate)
        this.setState({ startDate, endDate });        
    }
    
    onStartDateOffSetSelected(selectedDate){     
        this.selectedDate = selectedDate.clone()
        return selectedDate.isoWeekday(1)
    }

    render() {
        return (
            <div className="calendar_container">             
                <CFDateRangePicker
                    required={true}
                    numberOfMonths={1}
                    isRangeController={true}
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                    onDatesChange={this.setSelectedDate} // PropTypes.func.isRequired,
                    onStartDateOffSetSelected={this.onStartDateOffSetSelected}
                    singleDate={this.state.singleDate}
                    key={moment(this.state.endDate).format("YYYY-MM-D")}
                />            
            </div>
        )
    }
}

function mapStateToProps(state) {
	return {
        selectedStartDate: state.schedules.selectedStartDate,
        selectedEndDate: state.schedules.selectedEndDate,
        User: state.common.user,
        position: state.common.position,
	};
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch)
	};
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ScheduleWeekCalendar);






// WEBPACK FOOTER //
// ./src/features/common/ScheduleWeekCalendar.js